jQuery(document).ready(function($) {
  var gformSubmitted = false;
    $(".gform_wrapper form").submit(function(event) {
        if (gformSubmitted) {
            event.preventDefault();
        } else {
            gformSubmitted = true;
            $("button[type='submit']", this).html("<i class='fas fa-spinner fa-spin'></i>").attr("disabled", true);
        }
    });
})
